// Use this to dynamically load parts of the product page JS
// Dynamically loading scripts only at times they are required
// significantly improves performance and consequently SEO

// The comments are "magic comments" that specify the name of the sub-bundle
import { DateRangePicker } from "@/datepicker_script/datepicker";

export default class ModuleLoader {
	async getReviewsApp() {
		const module = await import(
			/* webpackChunkName: "reviews" */
			`@/vue/reviews/App.vue`
		);
		return module["default"];
	}

	async getStationApp() {
		const module = await import(
			/* webpackChunkName: "station" */
			`@/vue/station-domain/App.vue`
		);
		return module["default"];
	}

	async getMapApp() {
		const module = await import(
			/* webpackChunkName: "map" */
			`@/vue/map/App.vue`
		);
		return module["default"];
	}

	async getClubAdvantagesApp() {
		const module = await import(
			/* webpackChunkName: "map" */
			"@/vue/club-advantages/App.vue"
		);

		return module["default"];
	}

	async getDatepicker() {
		// const {DateRangePicker} = await import(
		//     /* webpackChunkName: "datepicker" */
		//     `@/datepicker_script/datepicker.js`
		// )
		return DateRangePicker;
	}
}
